<template>
  <div>
    Remove
  </div>
</template>

<script>
export default {
  name: 'Remove'
}
</script>



// WEBPACK FOOTER //
// src/views/Remove.vue